
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M256 12.751l-59.95 185.35H0l158.7 115.6-59.899 185.55 157.2-114.55 157.2 114.55-59.899-185.55 158.7-115.6h-196.05zm0 78.999l42.15 130.55H437.4l-112.65 82.15 42.35 131.1L256 354.549V91.739z"}})])
      }
    
      }
    